module.exports = __webpack_public_path__ + "img/logo.e51d9e16.png";